import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Box, Button, Card, Flex, TextInput, Title } from '@mantine/core'
import { getHotkeyHandler } from '@mantine/hooks'
import { useRouter } from 'next/router'
import { useMemo, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useStoreDates } from '../../hooks/useStoreDates'
import { useStoreDetails } from '../../hooks/useStoreDetails'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import { SectionDatesSelector } from '../SectionDatesSelector/SectionDatesSelector'
import styles from './styles.module.css'

export function SectionHero() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-home' })
  const store = useStoreDetails()
  const router = useRouter()
  const path = useStorePathBuilder()

  const [term, setTerm] = useState('')
  const [isRedirecting, setIsRedirecting] = useState(false)

  const { startAt, endAt, setStartAt, setEndAt } = useStoreDates()

  const link = useMemo(
    () => path(`/search?term=${encodeURI(term)}`),
    [store, term]
  )

  return (
    <Box pt='lg' mt='lg'>
      <Box className={styles.header}>
        <Box className={styles.headerIntro}>
          <Title order={3} c='dimmed' mb='sm'>
            {store?.name}
          </Title>
          <Title order={1} className={styles.hero} lineClamp={5}>
            {store?.slogan?.replace(/<[^>]*>?/gm, '')}
          </Title>
        </Box>
        <Box mt='md' className={styles.cardWrapper}>
          <Card className={styles.cardIntro} padding={0}>
            <Title order={3} mb='lg'>
              {t('card_rent_now.title')}
            </Title>
            <Flex align='center' gap='sm'>
              <Flex
                align='center'
                justify='center'
                h={22}
                w={22}
                bg='dark.9'
                style={{ borderRadius: 100 }}
              >
                <Title order={6} lh={1} c='white'>
                  1
                </Title>
              </Flex>
              <Title order={5}>{t('card_rent_now.label_first')}</Title>
            </Flex>
            <SectionDatesSelector
              mt='sm'
              size='lg'
              startAt={startAt}
              endAt={endAt}
              placeholderStartAt={t('card_rent_now.placeholder_start_date')}
              placeholderEndAt={t('card_rent_now.placeholder_end_date')}
              showCalendarIcon={false}
              withLabels={false}
              withDateOnly
              isInline
              onChangeStartAt={setStartAt}
              onChangeEndAt={setEndAt}
            />
            <Flex align='center' gap='sm' mt='lg'>
              <Flex
                align='center'
                justify='center'
                h={22}
                w={22}
                bg='dark.9'
                style={{ borderRadius: 100 }}
              >
                <Title order={6} lh={1} c='white'>
                  2
                </Title>
              </Flex>
              <Title order={5}>{t('card_rent_now.label_second')}</Title>
            </Flex>
            <TextInput
              placeholder={t('card_rent_now.placeholder_search')}
              size='lg'
              mt='sm'
              value={term}
              onChange={(e) => {
                setTerm(e.target.value)
              }}
              onKeyUp={getHotkeyHandler([
                [
                  'Enter',
                  () => {
                    if (term.length > 2) {
                      setIsRedirecting(true)
                      router.push(link)
                    }
                  },
                ],
              ])}
            />
            <Button
              size='xl'
              fullWidth
              mt='xl'
              loading={isRedirecting}
              onClick={() => {
                setIsRedirecting(true)
                router.push(link)
              }}
            >
              {t('card_rent_now.label_button')}
              <Icon icon={faArrowRight} ml='sm' />
            </Button>
          </Card>
        </Box>
      </Box>
    </Box>
  )
}
